import { createClient } from '@supabase/supabase-js';

// Las variables REACT_APP_* permiten configurar cada entorno sin modificar código.
// Los valores de compatibilidad conservan el funcionamiento del ZIP original.
const supabaseUrl =
  process.env.REACT_APP_SUPABASE_URL ||
  'https://ebnjrahanjoquwaayqzm.supabase.co';
const supabaseAnonKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVibmpyYWhhbmpvcXV3YWF5cXptIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQwNTM5NzgsImV4cCI6MjA3OTYyOTk3OH0.oaJKkUDTGiKo4UWvmWtcThgVR8wtcfGPEpJaGS22tLg';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
